module.exports = __webpack_public_path__ + "static/media/bg-mobile.dab261f6.png";